// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import ajax from "./server";
import menu from "./menu";
import "./style/global.css";
import "./filter";
import "babel-polyfill";
import echarts from "echarts";
import store from './store'
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.prototype.ajax = ajax;
Vue.prototype.menu = menu;

// Vue.prototype.$video = Video



const segmentColorStyle = (data, key) => {
  switch (key) {
      case 'bigTitle':
          key = 'bigTitleColor'
          break;
      case 'smallTitle':
          key = 'smallTitleColor'
          break;
      case 'seq':
          key = 'fontColor'
          break;
      default:
          break;
  }
  if (data && data[key]) {
      return `color:${data[key]};`
  } else return ''
}

Vue.prototype.$colorStyle = segmentColorStyle
// Vue.prototype.checkPermiss = str => {
//   let permissList = JSON.parse(sessionStorage.getItem("permiss")) || [];
//   return permissList.indexOf(str) > -1;
// };
import checkBtn from "@/util/checkBtnPermiss.js";
Vue.use(checkBtn);

Vue.use(ElementUI);
// router.beforeEach((to, from, next) => {
//   let permissList = JSON.parse(sessionStorage.getItem("permiss")) || [];
//   let routerPermiss = to.meta.permiss;
//   if (routerPermiss) {
//     let isHavePermission = false;
//     for (const item of permissList) {
//       if (item.resourceCode === routerPermiss) {
//         isHavePermission = true;
//         break;
//       }
//     }
//     isHavePermission ? next() : next("/404");
//   } else {
//     next();
//   }
// });

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js